module.exports = __webpack_public_path__ + "static/solution-admin-fa7d06534b9122afc72291cd26f4f98b.png";